import Image1 from "../Customers/Customers-images/Ellipsecustomer1.png";
import Image2 from "../Customers/Customers-images/Ellipsecustomer2.png";
import Image3 from "../Customers/Customers-images/Ellipsecustomer3.png";
import Image4 from "../Customers/Customers-images/Ellipsecustomer4.png";
export const CustomerData = [
  { image: Image1,  name: 'John Doe', 
  description: 'A brief description for John.' },
  { image: Image2, 
    name: 'Jane Smith', 
    description: 'A brief description for Jane.'  },
  { image: Image3 , 
    name: 'Alice Johnson', 
    description: 'A brief description for Alice.' },
  { image: Image4, 
    name: 'Bob Brown', 
    description: 'A brief description for Bob.'  },
    { image: Image3 , 
        name: 'Alice Johnson', 
        description: 'A brief description for Alice.' },
];
